import "./index.scss";
import { DSButton } from "components/UI/atoms";
import { FEEDBACK_TEXTS } from "./utils/constants";
import { useNavigate } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import { formatFullYearDate } from "utils/format";

export const OrderFeedback = ({
  isScheduled,
  isGift,
  payment,
  totals,
  line_items,
  gifting_email,
  sendLater,
  sendDate
}) => {
  const navigate = useNavigate();

  const { processing, additional, receipt, orders, giftDesc } = FEEDBACK_TEXTS;
  const { email: receiptEmail } = payment;
  const { total } = totals;
  const { title: brandName } = line_items[0];

  const amount = total / 100;

  const giftTitle = `A $${amount} ${brandName} gift card will be sent to ${gifting_email} ${
    sendLater && sendDate ? "on " + formatFullYearDate(sendDate) : ""
  }`;

  return (
    <div className="order-feedback">
      <div className="feedback-container">
        {isScheduled ? (
          <>
            <p aria-label={processing}>{processing}</p>
            <p aria-label={additional}>{additional}</p>
          </>
        ) : (
          <>
            {receiptEmail && (
              <h4 aria-label={`${receipt}${receiptEmail}`}>
                {receipt}
                {receiptEmail}
              </h4>
            )}
            <p aria-label={orders}>{orders}</p>
          </>
        )}
        <div className="feedback-buttons">
          <DSButton
            variant="outlined"
            customClassName="feedback-button my-orders"
            tabIndex={-1}
            size="large"
            onClick={() => navigate(INTERNAL_PATHS.MY_ORDERS)}
          >
            MY ORDERS
          </DSButton>
          <DSButton
            variant="secondary"
            customClassName="feedback-button"
            tabIndex={-1}
            size="large"
            onClick={() => navigate(INTERNAL_PATHS.HOME)}
          >
            CONTINUE SHOPPING
          </DSButton>
        </div>
      </div>
      {isGift && (
        <div className="feedback-container">
          <h2 aria-label={giftTitle}>{giftTitle}</h2>
          <p aria-label={giftDesc}>{giftDesc}</p>
        </div>
      )}
    </div>
  );
};
